export enum Scope {
  SingleInstance = 0,
  InstancePerDependency = 1,
}
